import { createContext, useContext } from "react";
import type { CampaignKey } from "@/campaigns/campaign-key";
import { useAppStore } from "@/stores";

/**
 * Shows one campaign on whichever surface hosts the caller: the widgets route
 * to its page, the overlay selects it in the rail. Provided by the surface's
 * root rather than imported, so shared UI (the notification toasts) never pulls
 * a router into a bundle that has none. Without a provider it only selects.
 */
export type NavigateToCampaign = (key: CampaignKey) => void;

const selectCampaign: NavigateToCampaign = (key) =>
  useAppStore.getState().setSelectedCampaignId(key);

export const CampaignNavigationContext =
  createContext<NavigateToCampaign>(selectCampaign);

export function useCampaignNavigation(): NavigateToCampaign {
  return useContext(CampaignNavigationContext);
}
